import { PAGE_ELEMENT_ID, BACKGROUND_ELEMENT_ID } from 'crazyEditor/core/elements/utils/elementStaticUtils';

const STATIC_ELEMENTS_LIST = 'staticElements';
const ELEMENTS_LIST = 'elements';

export const getElementList = (elementId) => [PAGE_ELEMENT_ID, BACKGROUND_ELEMENT_ID].indexOf(elementId) !== -1 ? STATIC_ELEMENTS_LIST : ELEMENTS_LIST;
